module.exports = __webpack_public_path__ + "static/media/colorfulLine.24e44ffe.svg";